const isArrayEmpty = (array) => {
    return array.length <= 0
}

export default isArrayEmpty